const NS = 'NOTIFICATION/';

export const SUCCESS = `${NS}SUCCESS`;
export const ERROR = `${NS}ERROR`;
export const SET_I18N = `${NS}SET_I18N`;
